import { appContext } from '../../../../AppContext';
import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import Helper from '../../../../Common/Helper';
import { PagedResponse } from "@iconics/core";
import { Ontology } from './DataModels';
import { JSX } from 'react';
import { IRouterProps, withRouting } from "@iconics/components";
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons } from "@iconics/components";
import { SerendieSymbol } from '@serendie/symbols';
import { TypeHelper } from '@iconics/core';

class ListOntologies extends IbssPage<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get local() { return appContext().localStorageProvider; }

    private userCanCreate: boolean;

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            gridData: { rows: [] },
        };

        this.userCanCreate = this.local.hasRight('DATAMODEL.Ontologies.Create');
    };

    public async componentDidMount(): Promise<void>
    {
        this.pageTitle = appContext().labels.Platform_Ontology_PageTitle;
    }

    private async handleRowsRequest(request: IGridRowsRequest<IOntology>): Promise<IGridRowsResponse<IOntology>>
    {
        const response = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.ontologies.get<PagedResponse<Ontology[]>>({
            select: Ontology,
            tenancy: appContext().tenantId,
            skipToken: request.skipToken,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        const ontologies = response.value.map(i => ({
            id: i.Id,
            name: i.Name,
            description: i.Description,
            enabled: TypeHelper.toBoolean(i.IsEnabled) ?? false,
            etag: i['@odata.etag'],
        } as IOntology));

        return { rows: ontologies, nextSkipToken: response.skipToken };
    }

    public render(): JSX.Element
    {
        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        icon={<SerendieSymbol name='loader' />}
                        title={this.labels.Platform_Ontology_ListTitle}
                        subTitle={this.labels.Platform_Ontology_ListSubTitle}
                    >
                        <GridContainer>
                            <GridItem>
                                <ButtonBar>
                                    <RightButtons>
                                        <Button
                                            size='small'
                                            styleType='ghost'
                                            leftIcon={<SerendieSymbol name='plus' />}
                                            onClick={() => this.props.navigate(`/admin/ontologies/new`)}
                                            disabled={!this.userCanCreate}
                                        >
                                            {this.labels.Platform_CommonAction_Add}
                                        </Button>
                                    </RightButtons>
                                </ButtonBar>
                            </GridItem>
                            <GridItem>
                                <DataGrid
                                    columns={[
                                        {
                                            columnId: Helper.nameOf<Ontology>("Name"),
                                            title: this.labels.Ontology_Name,
                                            getCellValue: i => i.name,
                                            columnWidth: 40,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Ontology>("Description"),
                                            title: this.labels.Ontology_Description,
                                            getCellValue: i => i.description,
                                            columnWidth: 40,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Ontology>("IsEnabled"),
                                            title: this.labels.Ontology_IsEnabled,
                                            getCellValue: i =>
                                                <SerendieSymbol
                                                    name={i.enabled ? 'check-circle' : 'close-circle'}
                                                    style={{ marginLeft: '32px' }}
                                                />,
                                            columnWidth: 20,
                                            sortable: true,
                                        },
                                    ]}
                                    data={this.state.gridData}
                                    rowId={i => i.id}
                                    onChange={i => this.setState({ gridData: i })}
                                    onRowsRequest={i => this.handleRowsRequest(i)}
                                    onCellClicked={i => this.props.navigate(`/admin/ontologies/${i.id}/edit`)}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        )
    }
}

export default withRouting(ListOntologies);

export interface IProps extends IRouterProps { }

export interface IState
{
    gridData: IGridData<IOntology>;
}

export interface IOntology
{
    id: string;
    name: string;
    description: string;
    enabled: boolean;
    etag: string;
}
